import styled, { css, keyframes } from 'styled-components';

import { BREAKPOINTS } from '../../../../common/styles/style-constants';

export const WelcomeStepContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 70vh;

  && .main-content {
    z-index: 999;
  }
`;

const wrapperMobileStyles = css`
  position: fixed;
  left: 50%;
  bottom: 0;
  padding: 20px 0;
  margin: auto 0;
  transform: translateX(-50%);
`;

export const ButtonWrapper = styled.div`
  && {
    display: flex;
    justify-content: center;
    margin-top: 20px;

    ${(props) => props.forceMobile && wrapperMobileStyles}
    /* This comment fixes a weird bug where space after the at-rule is added*/
    @media (max-width: ${BREAKPOINTS.mobileMax}px) {
      ${wrapperMobileStyles}
    }
  }
`;

const fadeIn = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

const bezier = 'cubic-bezier(0.8, 0, 0.5, 1)';

const animateOnce = '1 normal forwards';

export const FadeIn = styled.div`
  animation: ${animateOnce};
  animation-name: ${fadeIn};
  animation-duration: 1s;
  animation-timing-function: ${bezier};
`;
